/**
 * Die Bedingungsstruktur und ihre Darstellung.
 *
 * Eigene Datei und nicht bei der Komponente: Eine Datei, die neben einer
 * Komponente noch Konstanten ausgibt, faellt aus dem schnellen Neuladen von
 * React heraus -- die Entwicklungsumgebung laedt dann bei jeder Aenderung die
 * ganze Seite neu.
 */

/** Eine einzelne Bedingungszeile, wie der Server sie erwartet. */
export interface ConditionRule {
  field: string;
  op: string;
  value?: unknown;
}

export interface ConditionGroup {
  operator: 'and' | 'or';
  rules: ConditionRule[];

  // Der Server nimmt die Bedingung als offenes Objekt entgegen (siehe
  // automation/schemas.py: geprueft wird sie dort, wo die Erlaubnisliste der
  // Felder liegt). Der erzeugte Client bildet das als Index ab -- ohne diese
  // Zeile passt die Struktur hier nicht darauf.
  [key: string]: unknown;
}

/** Vergleiche ohne Wert -- sie fragen nur, ob etwas dasteht. */
export const VALUELESS_OPERATORS = new Set(['is_empty', 'is_not_empty']);

/** Vergleiche, die eine Zahl erwarten. */
export const NUMERIC_OPERATORS = new Set(['greater_than', 'less_than']);

/**
 * Der Wert einer Bedingung als Text.
 *
 * Er ist Text, Zahl, Wahrheitswert oder eine Liste davon -- ein Objekt kommt
 * nicht vor, weil der Server nichts anderes annimmt. `String()` blind darauf
 * anzuwenden waere trotzdem unsauber: Bei einem Objekt stuende
 * "[object Object]" in der Oberflaeche, und niemand wuesste, was gemeint ist.
 */
export function formatConditionValue(value: unknown): string {
  if (value === null || value === undefined) return '';
  if (Array.isArray(value)) return value.map(formatConditionValue).join(', ');
  if (typeof value === 'object') return JSON.stringify(value);
  // eslint-disable-next-line @typescript-eslint/no-base-to-string -- oben ausgeschlossen
  return String(value);
}
